import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import 'whatwg-fetch';

export const searchProducts = createAsyncThunk('products/search', async (keyword) => {
    const params = new URLSearchParams(window.location.search);
    params.set('keyword', keyword);
    try {
        const resp = await fetch(`${process.env.API_URL}/products/search?${params.toString()}`).then(resp => resp.json());
    
        if (resp && resp.success) {
            return resp;
        }
    } catch (e) {
        console.error(e);
    }
});

export const searchProduct = createAsyncThunk('products/search-id', async (productId) => {
    const params = new URLSearchParams(window.location.search);
    params.set('productId', productId);
    try {
        const resp = await fetch(`${process.env.API_URL}/products/search?${params.toString()}`).then(resp => resp.json());
    
        if (resp && resp.success) {
            return resp;
        }
    } catch (e) {
        console.error(e);
    }
});

// export const getProduct = createAsyncThunk('products/get', async ({ productId }) => {
//     const params = new URLSearchParams(window.location.search);
//     try {
//         const resp = await fetch(`${process.env.API_URL}/products/${id}?included_fields=name,sku&${params.toString()}`).then(resp => resp.json());
    
//         if (resp && resp.success) {
//             return resp;
//         }
//     } catch (e) {
//         console.error(e);
//     }
// });

const productsSlice = createSlice({
    name: 'products',
    initialState: {
        loading: 'idle',
        // productById: {},
        search: [],
        searchByProductId: {},
    },
    extraReducers: {
        [searchProducts.pending]: (state) => {
            state.loading = 'pending';
        },
        [searchProducts.fulfilled]: (state, action) => {
            state.loading = 'idle';
            state.search = (action.payload.data || []).map(item => ({
                value: item.id,
                content: item.name,
                description: item.sku ? `SKU: ${item.sku}` : '',
            }));
        },
        [searchProduct.pending]: (state) => {
            state.loading = 'pending';
        },
        [searchProduct.fulfilled]: (state, action) => {
            state.loading = 'idle';
            if (action.payload.data && action.payload.data.length > 0) {
                action.payload.data.forEach(item => {
                    state.searchByProductId[item.id] = [{
                        value: item.id,
                        content: item.name,
                        description: item.sku ? `SKU: ${item.sku}` : '',    
                    }];
                })
            }
        },
        // [getProduct.pending]: (state) => {
        //     state.loading = 'pending';
        // },
        // [getProduct.fulfilled]: (state, action) => {
        //     state.loading = 'idle';
        //     state.productById[action.payload.id] = action.payload;
        // },
    }
});

export default productsSlice.reducer;